export function dateDiffInDays(a: Date, b: Date) {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

export function isValidJSON(str: string) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

export const formatDate = (dateString: string) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const stringValidator = (str: any) => {
  if (typeof str === "string") {
    return str.trim() !== "";
  }
  if (typeof str === "number" || typeof str === "boolean") {
    return String(str).trim() !== "";
  }
  return false;
};

export const formatString = (str: any) => {
  if (typeof str === "string") {
    return str.trim().toLowerCase().replace(/\.$/, "");
  }
  if (typeof str === "number" || typeof str === "boolean") {
    return String(str).toLowerCase().replace(/\.$/, "");
  }
  return "";
};

export const HARD_CODED_QB_CONFIG = {
  themes: [
    {
      name: "Theme",
      label: "Theme",
      type: "select",
      topics: [
        {
          name: "Topic",
          label: "Topic",
          type: "select",
          learning_objectives: [
            {
              name: "Learning Objective",
              label: "Learning Objective",
              type: "select",
              questions: [
                {
                  question_name: "Question 1",
                  item_demand: {
                    label: "Item Demand",
                    value: "complexity",
                    type: "select",
                    options: ["Knowledge", "Comprehension", "Application"],
                  },
                  answer: {
                    label: "Answer",
                    value: "the answer",
                    type: "text",
                  },
                  explanation: {
                    label: "Explanation",
                    value: "the explanation",
                    type: "textarea",
                  },
                  image: {
                    label: "Item",
                    name: "file_name/image_name",
                    value: "image url",
                    type: "image",
                    image_summary: "summary of image",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const NOT_AVAILABLE_TEXT = "N/A";
